import React from 'react'

export function useCycle (between) {
  const [value, setValue] = React.useState(0)
  const cycle = () => {
    setValue((value + 1) % between.length)
  }
  return [between[value], cycle]
}